import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Preloader from "../Miscellaneous/Preloader";
import { useLocation } from "react-router-dom";
// import LenisScroll from "../Header/LenisScroll";

const RequestDemo = () => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 0);
    });
  }, [location.pathname]);

  const getResponsivePadding = () => {
    if (windowWidth < 480) return 16;
    if (windowWidth < 768) return 20;
    if (windowWidth < 1024) return 30;
    if (windowWidth < 1200) return 40;
    return 60;
  };

  const paddingInline = getResponsivePadding();
  const isMobile = windowWidth < 768;
  // const isTablet = windowWidth >= 768 && windowWidth < 1024;
  const isTablet = windowWidth >= 768 && windowWidth < 1025;
  const hideForm = windowWidth < 1024;

  const [formData, setFormData] = useState({
    type: "",
    fullName: "",
    email: "",
    company: "",
    jobTitle: "",
    additionalInfo: "",
  });

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({ ...formData, [name]: type === "radio" ? value : value });
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.type) newErrors.type = "Please select a request type";
    if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }
    if (!formData.company.trim()) newErrors.company = "Company is required";
    if (!formData.jobTitle.trim()) newErrors.jobTitle = "Job title is required";
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const requestTypeMessage =
        formData.type === "access"
          ? "The user is requesting access to the Ravity platform."
          : "The user is requesting a demo of the Ravity platform.";
      const requestBody = [
        {
          action: "add user",
          requesttype: formData.type === "access" ? "Request Access" : "Request Demo",
          fullname: formData.fullName,
          bussiness_email: formData.email,
          company: formData.company,
          login_email: formData.email,
          jobtitle: formData.jobTitle,
          additionalinfo: formData.additionalInfo,
        },
      ];
      const headers = {
        "Content-Type": "application/json",
        IngestionId: "22afb526-4d96-42d6-acaf-def92e193e8d",
        IngestionSecret: "ulKMkEKvEnhJs85tijF2TEqpbTGbqs4vyrO2H1hdP4HPrCGlDba63UFZJ7EWB8x",
      };

      try {
        const response = await fetch("https://platform.ravity.io/ingestion/dataIngestion", {
          method: "POST",
          headers: headers,
          body: JSON.stringify(requestBody),
        });

        const responseData = await response.json();

        if (response.ok) {
          console.log("Form submitted successfully", responseData);
          alert("Form submitted successfully!");
        } else {
          console.error("Error submitting the form:", responseData);
          alert("There was an error submitting the form. Please try again.");
        }
      } catch (error) {
        console.error("Error during the request:", error);
        alert("There was an error with the request. Please try again.");
      }
      setFormData({
        type: "",
        fullName: "",
        email: "",
        company: "",
        jobTitle: "",
        additionalInfo: "",
      });
    }
  };
  const clientLogos = [
    "../img/Award1.png",
    "../img/Award2.png",
    "../img/Award3.png",
    "../img/Award4.png",
    "../img/Award5.png",
    "../img/Award6.png",
    "../img/Award7.png"
  ];

  return (
    <div>
      <Preloader />
      {/* <LenisScroll /> */}
      <Header />
      <section id="home" className=""
        style={{ backgroundColor: "#0A0A1A", color: "#FFFFFF", paddingInline: `${paddingInline}px`, paddingBlock: isMobile ? "60px 40px" : hideForm ? "130px 50px" : "80px", height: hideForm ? "1820px" : "730px", }}
      >
        <div className="headerWd"
          style={{ display: "grid", gridTemplateColumns: hideForm ? "1fr" : "1fr 1fr", gap: hideForm ? "2rem" : "3rem", alignItems: "flex-start", maxWidth: "1400px", margin: "0 auto", }}
        >
          <div style={{ order: 1 }}>
            <h1 style={{ fontSize: hideForm ? "69px" : isTablet ? "36px" : "46px", fontWeight: 700, margin: hideForm ? "60px 0 130px" : "40px 0", color: "#fff", lineHeight: hideForm ? "140%" : "110%", textAlign: hideForm ? "center" : "left", }}>
              We'd love to show you around – grab a demo slot and explore our platform
            </h1>
            <p style={{ fontSize: hideForm ? "64px" : "18px", marginBottom: hideForm ? "120px" : "40px", fontWeight: "600", lineHeight: hideForm ? "200%" : "180%", textAlign: hideForm ? "center" : "justify", }}>
              Ravity works with leading OEMs like MG, Maruti, and Renault to ensure seamless, intelligent driving experiences.
            </p>

            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {[
                { text: "Enhance customer experience", icon: "../img/caseStudies1.png", },
                { text: "Reduce cost of warranty", icon: "../img/RequestIcon2.png", },
                { text: "Enable new revenue channel", icon: "../img/RequestIcon3.png", },
                { text: "AI driven vehicle operations", icon: "../img/RequestIcon4.png", },
              ].map((item, index) => (
                <li key={index} style={{
                  display: "flex", alignItems: "center", marginBottom: hideForm ? "40px" : "20px", fontSize: hideForm ? "52px" : "18px", justifyContent: isMobile ? "center" : "flex-start", gap: hideForm ? "36px" : "0px", marginLeft: hideForm ? "40px" : "0px"
                }}
                >
                  <div style={{ width: hideForm ? "95px" : "54px", height: hideForm ? "92px" : "50px", backgroundColor: "#FFFFFF", marginRight: "15px", borderRadius: "4px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", }}>
                    <img src={item.icon} alt="icon"
                      style={{ width: hideForm ? "76px" : "39px", height: hideForm ? "73px" : "37px", objectFit: "contain", }}
                    />
                  </div>
                  {item.text}
                </li>
              ))}
            </ul>

          </div>
          {!hideForm && (
            <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", padding: isMobile ? "20px" : isTablet ? "25px" : "30px", color: "#000000", marginTop: isMobile ? "0" : "52px", order: 2, width: "100%", maxWidth: isMobile ? "100%" : "none", }}>
              <div style={{
                display: "flex", justifyContent: isMobile ? "center" : "flex-end", flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? "15px" : "20px", marginBottom: "30px", fontWeight: "600", fontSize: isMobile ? "14px" : "16px", alignItems: isMobile ? "center" : "flex-start",
              }}
              >
                <label style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: isMobile ? "center" : "flex-start" }}>
                  <input type="radio" name="type" value="access" onChange={handleChange} checked={formData.type === "access"} />
                  Request Access
                </label>
                <label style={{display: "flex",alignItems: "center",gap: "8px",justifyContent: isMobile ? "center" : "flex-start"}}>
                  <input type="radio" name="type" value="demo" onChange={handleChange} checked={formData.type === "demo"} />
                  Request Demo
                </label>
              </div>
              {errors.type && (
                <div style={{textAlign: isMobile ? "center" : "right",marginTop: "-15px",marginBottom: "10px"}}>
                  <span style={{ color: "red", fontSize: isMobile ? "12px" : "13px" }}>{errors.type}</span>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                {[
                  { label: "Full Name*", name: "fullName" },
                  { label: "Business Email*", name: "email" },
                  { label: "Company*", name: "company" },
                  { label: "Job Title*", name: "jobTitle" },
                  { label: "Additional Information (Optional)", name: "additionalInfo" },
                ].map((field, idx) => {
                  const value = formData[field.name];
                  const hasValue = typeof value === "string" && value.trim() !== "";
                  return (
                    <div key={idx} style={{position: "relative",marginBottom: isMobile ? "25px" : "30px"}}>
                      <label htmlFor={field.name}
                        style={{position: "absolute",top: "-18px",left: "0",fontSize: isMobile ? "16px" : "18px",fontWeight: 600,color: hasValue ? "#000000" : "#A1A1A1",transition: "color 0.2s ease",}}
                      >
                        {field.label}
                      </label>
                      <input
                        id={field.name}
                        type="text"
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        style={{width: "100%",border: "none",borderBottom: "1px solid #ccc",padding: "8px 0",fontSize: isMobile ? "13px" : "14px",outline: "none",boxSizing: "border-box",}}
                      />
                      {errors[field.name] && (
                        <span style={{position: "absolute",right: 0,top: "50%",transform: "translateY(-50%)",fontSize: isMobile ? "11px" : "12px",color: "red",}}>
                          {errors[field.name]}
                        </span>
                      )}
                    </div>
                  );
                })}
                <button type="submit" style={{backgroundColor: "#0A0A14",color: "#FFFFFF",padding: isMobile ? "10px 18px" : "12px 20px",borderRadius: "4px",fontSize: isMobile ? "14px" : "16px",fontWeight: 500,border: "none",cursor: "pointer",width: isMobile ? "100%" : "auto",}}>
                  Submit Request
                </button>
              </form>
            </div>
          )}
        </div>
      </section>

      {/* Awards Section */}
      <section className="outcomesec" style={{ marginBottom: hideForm ? "320px" : "85px" }}>
        <div className="marquee headerWd" style={{minHeight: hideForm ? "1000px" : "650px",paddingInline: `${paddingInline}px`,}}>
          <h1 style={{fontWeight: 600,marginTop: hideForm ? "160px" : "-20px",marginBottom: isMobile ? "80px" : isTablet ? "300px" : "160px",fontSize: hideForm ? "86px" : "48px",lineHeight: "100%",letterSpacing: "0%",textAlign: "center",}}>
            Awards & Recognition
          </h1>
          <ul className="list-unstyled" style={{marginTop: isMobile ? "60px" : "100px",display: "flex",flexWrap: isMobile ? "wrap" : "nowrap",justifyContent: "center",gap: isMobile ? "20px" : "40px",alignItems: "center",}}>
            {clientLogos.concat(clientLogos).map((logo, index) => (
              <li key={index} className="item" style={{
                listStyle: "none", width: hideForm ? "330px" : "230px", height: hideForm ? "330px" : "230px",
                flexShrink: 0,
              }}>
                <a href="/" className="marquee-item rounded"
                  style={{textDecoration: "none",display: "flex",justifyContent: "center",alignItems: "center",padding: isMobile ? "10px" : "15px",height: "100%",width: "100%", }}
                >
                  <div className="marquee-content"
                    style={{display: "flex",alignItems: "center",justifyContent: "center",width: "100%",height: "100%",}}
                  >
                    <img src={logo} alt={`Brand ${index + 1}`}
                      style={{maxWidth: "100%",maxHeight: "100%",objectFit: "contain",}}
                    />
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default RequestDemo;